import { writable } from 'svelte-local-storage-store'
export const user_id = writable('user_id','')
export const email = writable('email','')
export const tier = writable('tier','')
